import { z } from 'zod';
import { claimList, claimListItem } from '../../schema/claim.js';
import { registrationListItem } from '../../schema/registration.js';
import { shippingClaimList, shippingClaimListItem, } from '../../schema/shippingClaim/shippingClaim.js';
const customerExtension = {
    originalStoreOrderId: z.number().optional(),
    kustomerEventId: z.string().nullable(),
};
export const storeCustomer = z.object({
    id: z.number(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    totalOrders: z.number(),
    orders: z.array(z.object({
        orderNo: z.string(),
        idFromPlatform: z.string(),
        createdOn: z.string(),
        orderTotal: z.string(),
        claims: z.array(claimListItem.extend(customerExtension)),
        shipProtectClaims: z.array(shippingClaimListItem.extend(customerExtension)),
    })),
    registrations: z.array(registrationListItem.extend(customerExtension)),
    claims: claimList,
    shippingClaims: shippingClaimList,
});
// claim history across every store; each list item carries its own `storeId` / `storeName`
export const conciergeCustomer = z.object({
    email: z.string(),
    claims: claimList,
    shippingClaims: shippingClaimList,
});
//# sourceMappingURL=storeCustomer.js.map